import { createSlice, createAction } from "@reduxjs/toolkit";

export const fetchBuyApproveData = createAction("buyApprove/fetch");
export const deleteBuyApprove = createAction("buyApprove/delete");
export const buyApproveAdded = createAction("buyApprove/added");
export const buyApproveUpdated = createAction("buyApprove/updated");

const initialState = {
  data: [],
  selectedBuyApproves: {},
  deleting: false,
  loading: false,
  error: null,
  success: null,
  total: 0,
  pageCount: 0,
  queryData: { pageIndex: 0, pageSize: 10, filter: {} },
  pageSelections: {},
};

const buyApproveSlice = createSlice({
  name: "buyApproves",
  initialState,
  reducers: {
    removeError(state, action) {
      if (action.payload !== undefined) {
        state.success = null;
      } else {
        state.error = null;
      }
    },
    syncFormData(state, action) {
      state.formData = action.payload;
    },
    onFilterSearch(state, action) {
      state.queryData = {
        ...state.queryData,
        filter: {
          ...state.queryData.filter,
          ...action.payload,
        },
        pageIndex: 1,
      };
    },
    pageCountChange(state, action) {
      state.pageCount = action.payload;
    },
    sortByChange(state, action) {
      state.queryData = {
        ...state.queryData,
        sortBy: action.payload,
        pageIndex: 1,
      };
    },
    pageSizeChange: (state, action) => {
      state.queryData.pageSize = action.payload;
      state.queryData.pageIndex = 0;
    },
    pageChange: (state, action) => {
      state.queryData.pageIndex = action.payload;
    },

    onBuyApproveSelection: (state, action) => {
      const { pageIndex, selections } = action.payload;
      state.pageSelections[pageIndex] = selections;
    },
    updateRowAfterUpdate(state, action) {
      const newItem = action.payload;
      state.data = state.data.map((item) =>
        item.licenseId === newItem.licenseId ? { ...item, ...newItem } : item
      );
    },
    initiateResetPassword(state) {
      state.loading = true;
    },
    resetPasswordSuccess(state, action) {
      state.loading = false;
      state.success = action.payload;
    },
    resetPasswordFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    buyApproveFetchSuccess(state, action) {
      const { data, total } = action.payload;
      const { pageSize } = state.queryData;
      state.data = data;
      state.total = total || 0;
      state.pageCount = Math.ceil(total / pageSize) || 1;
      state.loading = false;
    },
    buyApproveFetchFailed(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    deleteBuyApproveSuccess(state, action) {
      const id = action.payload;
      state.data = state.data.filter((item) => item.licenseId !== id);
      state.deleting = false;
    },
    deleteBuyApprovePending(state) {
      state.deleting = true;
    },
    deleteBuyApproveFailed(state, action) {
      state.error = action.payload;
      state.deleting = false;
    },
    resetBuyApproveData(state) {
      state.data = [];
      state.selectedBuyApproves = {};
      state.total = 0;
      state.pageCount = 0;
      state.queryData = {
        filter: {
          resellerId: "",
        },
        pageIndex: 1,
        pageSize: 10,
      };
    },
  },
});

export const {
  removeError,
  syncFormData,
  onFilterSearch,
  sortByChange,
  pageCountChange,
  pageSizeChange,
  pageChange,
  onBuyApproveSelection,
  updateRowAfterUpdate,
  initiateResetPassword,
  resetPasswordFailed,
  resetPasswordSuccess,
  buyApproveFetchSuccess,
  buyApproveFetchFailed,
  deleteBuyApproveFailed,
  deleteBuyApprovePending,
  deleteBuyApproveSuccess,
  resetBuyApproveData,
} = buyApproveSlice.actions;

export default buyApproveSlice.reducer;
